/**
 * TrashIcon — sanitized from `assets/newSvg/trash.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function TrashIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M14.2792,2 C15.1401,2 15.9044,2.55086 16.1766,3.36754 L16.7208,5 L20,5 C20.5523,5 21,5.44772 21,6 C21,6.55227 20.5523,6.99998 20,7 L19.9975,7.07125 L19.9975,7.07125 L19.1301,19.2137 C19.018,20.7837 17.7117,22 16.1378,22 L7.86224,22 C6.28832,22 4.982,20.7837 4.86986,19.2137 L4.00254,7.07125 C4.00083,7.04735 3.99998,7.02359 3.99996,7 C3.44769,6.99998 3,6.55227 3,6 C3,5.44772 3.44772,5 4,5 L7.27924,5 L7.82339,3.36754 C8.09562,2.55086 8.8599,2 9.72076,2 L14.2792,2 Z M9,10 C8.48715929,10 8.06449214,10.386027 8.00672766,10.8833761 L8,11 L8,17 C8,17.5523 8.44771,18 9,18 C9.51284071,18 9.93550786,17.613973 9.99327234,17.1166239 L10,17 L10,11 C10,10.4477 9.55229,10 9,10 Z M15,10 C14.4477,10 14,10.4477 14,11 L14,17 C14,17.5523 14.4477,18 15,18 C15.5523,18 16,17.5523 16,17 L16,11 C16,10.4477 15.5523,10 15,10 Z M14.2792,4 L9.72076,4 L9.38743,5 L14.6126,5 L14.2792,4 Z"
        fill={color}
      />
    </Svg>
  );
}

export default TrashIcon;
